import { ThemedContainer, ThemedContainerProps, useTheme } from "@amx/ux-twoui-theming";
import { IStackStyles, Stack } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../shared/logging";
import { useWatchViewport } from "../../styles/media";

export type HorizontalAlignType = "start" | "end" | "center" | "space-between" | "space-around" | "space-evenly" | "baseline" | "stretch";

export interface BaseLayoutProps extends ThemedContainerProps {
    readonly horizontal?: boolean;
    readonly horizontalAlign?: HorizontalAlignType;
}

const UnThemedBaseLayout: React.FC<BaseLayoutProps> = ({
    horizontal = true,
    horizontalAlign = "space-between",
    children
}) => {
    useWatchViewport();
    const theme = useTheme();

    const layoutStyles: IStackStyles = {
        root: {
            backgroundColor: theme.semanticColors.bodyBackground
        }
    };

    return (
        <Stack horizontal={horizontal} horizontalAlign={horizontalAlign} styles={layoutStyles}>
            {children}
        </Stack>
    );
};

export const BaseLayout: React.FC<BaseLayoutProps> = (props) => {
    useComponentLogger("BaseLayout");

    return (
        <ThemedContainer variant={props.variant}>
            <UnThemedBaseLayout {...props} />
        </ThemedContainer>
    );
};
